import React from "react";
import { Typography } from "@mui/material";

export default function RegionsStates({ results }) {
  return (
    results.map((r, i) => (
      <span key={i} style={{ margin: "0 0 2px 20px" }}>
        <Typography sx={{ margin: "10px 0" }}>
          {r.name}
        </Typography>
      </span>
    ))
  );
}